import { Editor, type JSONContent } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import { Markdown } from 'tiptap-markdown';

export const markdownToContentJson = (markdown: string): JSONContent => {
  const editor = new Editor({
    extensions: [
      StarterKit.configure({
        heading: false,
        blockquote: false,
        horizontalRule: false,
      }),
      Markdown.configure({ html: false }),
    ],
    content: markdown,
  });
  try {
    return editor.getJSON();
  } finally {
    editor.destroy();
  }
};
